import React, { Fragment } from 'react'
import { Formik, Form, Field, ErrorMessage } from 'formik';
//import { actualizarUsuarioAtencionACliente, agregarUsuarioAtencionACliente, reasignacionDeCartera, verificarUsuario } from '../../../../redux/DucksAtencionACliente/UsuariosAtencionAClienteDuck'
import { verificarUsuario } from '../../../redux/DucksAtencionACliente/UsuariosAtencionAClienteDuck';
import { useDispatch } from 'react-redux'
import { v4 as uuidv4 } from 'uuid';
import { withRouter } from 'react-router-dom'
import estilos from './ModalRegistrarUsuarioComponent.module.css'
import { DataGrid } from '@mui/x-data-grid';
import Fade from '@mui/material/Fade';
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import Backdrop from '@mui/material/Backdrop';
import Typography from '@mui/material/Typography';
import moment from 'moment'
import { useSelector } from 'react-redux'
import { FormControlLabel, Checkbox } from '@mui/material';
//import { agregarHistorialCartera } from '../../../../redux/DucksAtencionACliente/HistorialAtencionAClienteDucks'

const ModalRegistrarUsuarioComponent = (props) => {

    const dispatch = useDispatch()
    const usuarioModify = props?.usuarioModify

    const [open, setOpen] = React.useState(false);

    const [initialStateFormik, setInitialStateFormik] = React.useState({
        id: '',
        usuario: '',
        password: '',
        puesto: 'Auxiliar División Agrícola'
    })

    const [registroPredio, setRegistroPredio] = React.useState(false);
    const [descuentoPredio, setDescuentoPredio] = React.useState(false);
    const [reportes, setReportes] = React.useState(false);
    const [edicionDatos, setEdicionDatos] = React.useState(false);
    const [generarGuias, setGenerarGuias] = React.useState(false);
    const [catalogoMaguey, setCatalogoMaguey] = React.useState(false);
    const [constancias, setConstancias] = React.useState(false);
    const [informacionAsociados, setInformacionAsociados] = React.useState(false);
    const [informacionPredios, setInformacionPredios] = React.useState(false);

    const [openModalAlerta, setOpenModalAlerta] = React.useState(false)
    const [titleModalAlerta, setTitleModalAlerta] = React.useState('')
    const [bodyModalAlerta, setBodyModalAlerta] = React.useState('')
    const closeModalAlerta = () => setOpenModalAlerta(false)

    React.useState(() => {
        if (usuarioModify != null) {
            setInitialStateFormik({
                id: usuarioModify?.id,               
                usuario: usuarioModify?.usuario,
                password: usuarioModify?.password,
                puesto: usuarioModify?.puesto
            })
            setRegistroPredio(usuarioModify?.permisosagricola?.registroPredio)
            setDescuentoPredio(usuarioModify?.permisosagricola?.descuentoPredio)
            setReportes(usuarioModify?.permisosagricola?.reportes)
            setEdicionDatos(usuarioModify?.permisosagricola?.edicionDatos)
            setGenerarGuias(usuarioModify?.permisosagricola?.generarGuias)
            setCatalogoMaguey(usuarioModify?.permisosagricola?.catalogoMaguey)
            setConstancias(usuarioModify?.permisosagricola?.constancias)
            setInformacionAsociados(usuarioModify?.permisosagricola?.informacionAsociados)
            setInformacionPredios(usuarioModify?.permisosagricola?.informacionPredios)           
        }
    }, [props?.usuarioModify])

    const styleAlerta = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 350,
        bgcolor: 'background.paper',
        border: 'none',
        boxShadow: 24,
        p: 4,
    };

    const verificarUser = async (usuario) => {
        const user = await dispatch(verificarUsuario(usuario))
        return user.payload
    }

    const validarInputs = async (values) => {
        const errors = {};
        const textError = 'Campo obligatorio'
        if (!values.usuario) { errors.usuario = textError }
        else {
            if (usuarioModify) {
                if (values.usuario !== usuarioModify.usuario) {
                    const correoValidado = await verificarUser(values.usuario)
                    if (correoValidado) errors.usuario = 'El usuario ya se encuentra registrado'
                }
            } else {
                const correoValidado = await verificarUser(values.usuario)
                if (correoValidado) errors.usuario = 'El usuario ya se encuentra registrado'
            }
        }
        if (!values.password) { errors.password = textError }
        if (!values.puesto) { errors.puesto = textError }
        else if (values.puesto === 'default') { errors.puesto = textError }
        if (values.puesto === 'Ejecutivo' && !values.cartera) { errors.cartera = textError }

        return errors
    }

    const agregarUsuario = async (values) => {
        if(registroPredio == false && descuentoPredio == false && reportes == false && 
            edicionDatos == false && generarGuias == false && catalogoMaguey == false && 
            constancias == false && informacionAsociados == false && informacionPredios == false){ 
                setTitleModalAlerta("¡Alerta!")
                setBodyModalAlerta("Debe dar acceso a al menos un panel.")
                setOpenModalAlerta(true)
        } else{
            const usuario = {
                id: uuidv4(),
                usuario: values.usuario,
                password: values.password,
                puesto: values.puesto,
                registroPredio: registroPredio,
                descuentoPredio: descuentoPredio,
                reportes: reportes,
                edicionDatos: edicionDatos,
                generarGuias: generarGuias,
                catalogoMaguey: catalogoMaguey,
                constancias: constancias,
                informacionAsociados: informacionAsociados,
                informacionPredios: informacionPredios,
            }
            props.functionAcept(usuario)
        }        
    }

    const actualizarUsuario = async (values, usuarioModify) => {
        if(registroPredio == false && descuentoPredio == false && reportes == false && 
            edicionDatos == false && generarGuias == false && catalogoMaguey == false && 
            constancias == false && informacionAsociados == false && informacionPredios == false){ 
                setTitleModalAlerta("¡Alerta!")
                setBodyModalAlerta("Debe dar acceso a al menos un panel.")
                setOpenModalAlerta(true)
        } else{
            let usuario = {
                id: values.id,
                usuario: values.usuario,
                puesto: values.puesto,
                registroPredio: registroPredio,
                descuentoPredio: descuentoPredio,
                reportes: reportes,
                edicionDatos: edicionDatos,
                generarGuias: generarGuias,
                catalogoMaguey: catalogoMaguey,
                constancias: constancias,
                informacionAsociados: informacionAsociados,
                informacionPredios: informacionPredios,
            }
            
            if (usuarioModify.password !== values.password) {
                usuario.password = values.password
            }

            props.functionActualizar(usuario)
        }
    }

    return (
        <Fragment>
            <div className='row justify-content-center'>
                <div className={`col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 `}>
                        <h3 className={`${estilos.tituloForm}`}>{
                            usuarioModify ?
                                "EDITAR USUARIO DIVISIÓN AGRÍCOLA" :
                                "REGISTRAR USUARIO DIVISIÓN AGRÍCOLA"
                        }</h3>
                    <Formik initialValues={initialStateFormik}
                        validate={async values => {
                            const errors = await validarInputs(values)
                            return errors;
                        }}
                        onSubmit={async (values, { setSubmitting }) => {
                            if (usuarioModify) {
                                await actualizarUsuario(values, usuarioModify)
                            } else {
                                await agregarUsuario(values)
                            }
                            setSubmitting(false);
                        }} >
                        {({ isSubmitting, values }) => (
                            <Form>
                                <div className={`row mt-3 mb-3 ${estilos.contenedorForm}`}>
                                    <div className='col-md-12 mt-0'>
                                        <label htmlFor="puesto">Puesto:</label><br />
                                        <Field as="select" name="puesto" className='form-control'>
                                            {/*<option key='0'>Seleccione una opción</option>*/}
                                            <option value='Auxiliar División Agrícola'>Técnico de campo</option>
                                        </Field>
                                        <ErrorMessage name="puesto" component="div" className={`${estilos.error}`} />
                                    </div>
                                    <div className='col-md-6 mt-4'>
                                        <label>Usuario:</label><br />
                                        <Field type="text" name="usuario" className='form-control'></Field>
                                        <ErrorMessage name="usuario" component="div" className={`${estilos.error}`} />
                                    </div>
                                    <div className='col-md-6 mt-4'>
                                        <label>Contraseña:</label><br />
                                        <Field type="password" name="password" className='form-control'></Field>
                                        <ErrorMessage name="password" component="div" className={`${estilos.error}`} />
                                    </div>
                                    <div className='col-md-12 mt-4'>
                                        <label> Accesos: </label>
                                    </div>
                                    <div className="col-4 mt-3 ps-5">
                                        <FormControlLabel className='ps-3' value="top" control={<Checkbox color='success' checked={registroPredio} onChange={e => setRegistroPredio(e.target.checked)}   />} label="Registro de predio" />
                                    </div>
                                    <div className="col-4 mt-3 ps-5">
                                        <FormControlLabel className='ps-3' value="top" control={<Checkbox color='success' checked={descuentoPredio} onChange={e => setDescuentoPredio(e.target.checked)} />} label="Descuento por predio" />
                                    </div>
                                    <div className="col-4 mt-3 ps-5">
                                        <FormControlLabel className='ps-3' value="top" control={<Checkbox color='success' checked={reportes} onChange={e => setReportes(e.target.checked)} />} label="Reportes" />
                                    </div>
                                    <div className="col-4 mt-3 ps-5">
                                        <FormControlLabel className='ps-3' value="top" control={<Checkbox color='success' checked={edicionDatos} onChange={e => setEdicionDatos(e.target.checked)} />} label="Edición de datos" />
                                    </div>
                                    <div className="col-4 mt-3 ps-5">
                                        <FormControlLabel className='ps-3' value="top" control={<Checkbox color='success' checked={generarGuias} onChange={e => setGenerarGuias(e.target.checked)} />} label="Generar nuevas guías" />
                                    </div>
                                    <div className="col-4 mt-3 ps-5">
                                        <FormControlLabel className='ps-3' value="top" control={<Checkbox color='success' checked={catalogoMaguey} onChange={e => setCatalogoMaguey(e.target.checked)} />} label="Catálogo de maguey" />
                                    </div>
                                    <div className="col-4 mt-3 ps-5">
                                        <FormControlLabel className='ps-3' value="top" control={<Checkbox color='success' checked={constancias} onChange={e => setConstancias(e.target.checked)} />} label="Constancias" />
                                    </div>
                                    <div className="col-4 mt-3 ps-5">
                                        <FormControlLabel className='ps-3' value="top" control={<Checkbox color='success' checked={informacionAsociados} onChange={e => setInformacionAsociados(e.target.checked)} />} label="Información de asociados" />
                                    </div>
                                    <div className="col-4 mt-3 ps-5">
                                        <FormControlLabel className='ps-3' value="top" control={<Checkbox color='success' checked={informacionPredios} onChange={e => setInformacionPredios(e.target.checked)} />} label="Información de predios" />
                                    </div>
                                    <div className="col-12 mt-5 text-center">
                                        <button type="submit" disabled={isSubmitting} className='btn btn-success' style={{ fontFamily: 'Montserrat', width: '50%' }}>
                                            { usuarioModify ? "Guardar cambios" : "Registrar" }
                                        </button>
                                    </div>                                
                                </div>
                            </Form>
                        )}
                    </Formik>
                </div>
            </div>

            <Modal
                open={openModalAlerta}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={styleAlerta}>
                    <Typography id="modal-modal-title" variant="h6" component="h2" style={{ textAlign: 'center' }}>
                        <strong>{titleModalAlerta}</strong>
                    </Typography>
                    <Typography id="modal-modal-description" sx={{ mt: 3 }} style={{ textAlign: 'center' }}>
                        {bodyModalAlerta}
                    </Typography>
                    <Typography sx={{ mt: 5 }} className='text-center'>
                        <button className='btn btn-success' onClick={closeModalAlerta} style={{ width: '100%' }} > Aceptar </button>
                    </Typography>
                </Box>
            </Modal>
        </Fragment>
    )
}

export default withRouter(ModalRegistrarUsuarioComponent)